import React from "react"
import { Box, Paper, Grid, IconButton } from "@mui/material"

import { makeStyles } from "makeStyles"

import Link from "components/i18n/Link"
import Price from "components/Price"
import LazyLoadedImage from "components/LazyLoadedImage"

import { AlgoliaLockingSystemHit } from "@secureo/common/typings/Algolia"

const useStyles = makeStyles()({
	attributes: {
		visibility: "hidden",
		marginTop: "-120px",
		opacity: 0.4,
	},
	button: {
		background: "#E3E5E6",
		width: 46,
		height: 46,
	},
	title: {
		height: 80,
		marginBottom: -20,
		color: "black",
		cursor: "pointer",
	},
	product: {
		boxShadow: "none",
		border: "1px solid whitesmoke",
		borderRadius: 10,
		// transition: "0.3s",
		position: "relative",
		// height: 330,
		"&:hover": {
			position: "absolute",
			boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.35)",
			border: "1px solid #4691CE",
			transition: "0.3s",
			zIndex: 1,
			"& $button": {
				background: "#4691CE",
				color: "white",
				boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.35)",
			},
			"& $title": {
				color: "#4691CE",
			},
		},
	},
	badge: {
		position: "absolute",
		top: 15,
		left: 15,
		fontSize: 10,
		textTransform: "uppercase",
		border: "1px solid #4691CE",
		color: "#4691CE",
		borderRadius: 5,
		paddingLeft: 5,
		paddingRight: 5,
		"&:hover": {
			color: "white",
			background: "#4691CE",
			cursor: "pointer",
		},
	},
})

const LockingSystemGridViewItem = ({ hit }: Props) => {
	const { classes } = useStyles()

	const { name, image, slug, securityScore = null, grossPriceCents } = hit

	return (
		<Link href={`/locking-system/${slug}`}>
			<div style={{ position: "relative" }}>
				<Paper className={classes.product}>
					<Box p={2}>
						<Grid container spacing={3}>
							<Grid item xs={12} md={12} style={{ textAlign: "center" }}>
								<LazyLoadedImage
									alt={name}
									title={name}
									src={image}
									style={{
										height: 130,
										width: 150,
										objectFit: "contain",
										margin: "auto",
										marginBottom: -20,
									}}
								/>
							</Grid>

							<Grid item xs={12} md={12} style={{ margin: 10 }}>
								<div className={classes.title}>
									<strong>{name}</strong>
								</div>
								<div className={classes.attributes}>
									{securityScore !== null && (
										<span>
											<br />
											Sicherheitsstufe: {securityScore} / 10
										</span>
									)}
									{/* <ul>
										{previewBulletPoints.map((previewBulletPoint) => (
											<li key={previewBulletPoint}>{previewBulletPoint}</li>
										))}
									</ul> */}
								</div>
							</Grid>

							<Grid item xs={12}>
								<div style={{ display: "flex", justifyContent: "space-between" }}>
									<Box ml={1}>
										<strong style={{ fontSize: 22, marginRight: 5 }}>
											<Price priceInEuroCents={grossPriceCents} />
										</strong>
										<span style={{ color: "grey", fontSize: 12 }}>
											inkl. MwSt.
										</span>
										<br />
									</Box>
									<IconButton
										aria-label="delete"
										className={classes.button}
										size="large"
									>
										&rarr;
									</IconButton>
								</div>
							</Grid>
						</Grid>
					</Box>
				</Paper>
			</div>
		</Link>
	)
}

interface Props {
	hit: AlgoliaLockingSystemHit
	locale: string
	position: number
	categoryName: string
	listName?: string
}

export default LockingSystemGridViewItem
